import {
  Injectable,
  Injector,
  ComponentFactoryResolver,
  EmbeddedViewRef,
  ApplicationRef,
  ComponentRef
} from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { loadingScreen } from 'src/app/interfaces/ui'; 

@Injectable()
export class DomService {

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) { }

  loadingModalBS = new BehaviorSubject<loadingScreen>(null);
  loadingModal$ = this.loadingModalBS.asObservable();

  appendComponentToElement(component: any, domElement: any) {
    // Create a component reference from the component 
    const componentRef = this.componentFactoryResolver
      .resolveComponentFactory(component)
      .create(this.injector);

    // Attach component to the appRef so that it's inside the ng component tree
    this.appRef.attachView(componentRef.hostView);

    // Get DOM element from component
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    // Append DOM element to the body
    domElement.appendChild(domElem);

    return componentRef;
  }

  destroyElement(componentRef: any) {
    this.appRef.detachView(componentRef.hostView);
    componentRef.destroy();
  }


}